const api = async ({ url, method = "GET", headers, payload, activeSession }) => {
  try {
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...(activeSession.sessionToken && { Authorization: `Bearer ${activeSession.sessionToken}` }),
        "VZ-M2M-Token": activeSession.sessionToken,
        ...headers,
      },
      body: method === "GET" ? null : JSON.stringify(payload),
    });
    const reponseJson = await response.json();
    if (reponseJson.error) {
      if (
        reponseJson.error_description ===
        "Invalid token type in Authorization header."
      ) {
        alert("Invalid Token, Please login first");
      } else if (reponseJson.error === "unauthorized_client") {
        alert(
          "This user is not authorized to fetch device list, please log in as device user"
        );
      } else if (reponseJson.error === "bad_request") {
        alert("Bad request");
      }

      return new Error(reponseJson.error);
    }
    return reponseJson;
  } catch (error) {
    return new Error("api failed");
  }
};

export const capitalizeWords = (str) => {
  const capitalize = (str) => {
    if (typeof str !== "string") return "";
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase();
  };

  if (typeof str !== "string") return "";
  if (!str) return "";
  return str.split(" ").map((word) => capitalize(word)).join(" ");
};

export default api;
